import { eventShowcaseService } from '@project/services';
import { useQuery } from '@tanstack/react-query';
import {
  EventShowcaseCategoryListModel,
  EventShowcaseCategoryModel,
  EventShowcaseModel,
} from './events-showcase.model';

export const useGetShowcaseCategories = () => {
  return useQuery(
    ['showcase-categories'],
    async () => eventShowcaseService.getShowcaseCategories(),
    {
      select: EventShowcaseCategoryListModel,
    },
  );
};

export const useGetShowcaseCategory = (id: string | undefined) => {
  return useQuery(
    ['showcase-category', id],
    async () => eventShowcaseService.getShowcaseCategory(id || ''),
    {
      select: EventShowcaseCategoryModel,
      enabled: !!id,
    },
  );
};

export const useGetShowcase = (id: string | undefined) => {
  return useQuery(['showcase', id], async () => eventShowcaseService.getShowcase(id || ''), {
    select: EventShowcaseModel,
    enabled: !!id,
  });
};
